export default __webpack_public_path__ + "static/media/remote-survey.8d114903.png";